import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {ReconciliationReportModel} from "./reconciliation-report-model.service";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";

@Component({
    selector: "wbo-reconciliation-report",
    templateUrl: "./reconciliation-report.component.html",
    providers: [provideReportModel(ReconciliationReportModel)]
})

export class ReconciliationReportComponent extends AbstractReportPage {
    constructor(public model: ReconciliationReportModel) {
        super();
    }
}
